<div class="sidebar-wrapper">
  <ul class="nav" *ngIf="isLoggedIn">
    <li>
      <a routerLink="/members" routerLinkActive="active">
          <i class="ti-user"></i>
          <p>Members</p>
      </a>
    </li>
    <li>
      <a routerLink="/waiting-list-applicants" routerLinkActive="active">
          <i class="ti-time"></i>
          <p>Waiting List</p>
      </a>
    </li>
    <li>
      <a routerLink="/plots" routerLinkActive="active">
          <i class="ti-layout-grid2"></i>
          <p>Plots</p>
      </a>
    </li>
    <li>
      <a routerLink="/items" routerLinkActive="active">
          <i class="ti-home"></i>
          <p>Authorised Items</p>
      </a>
    </li>
    <li>
      <a routerLink="/invoices" routerLinkActive="active">
          <i class="ti-money"></i>
          <p>Invoices</p>
      </a>
    </li>
  </ul>
</div>
